import styled from 'styled-components';

type Style = 'warning-primary' | 'warning-secondary' | 'remove-secondary';

export const Container = styled.button.attrs<{ 'data-style'?: Style }>({
  type: 'button',
})(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10rem',

  paddingInline: '20rem',
  paddingBlock: '8rem',

  borderRadius: '20rem',
  border: `1.5rem solid ${theme.page.nextStepBtn.text}`,

  backgroundColor: theme.page.nextStepBtn.bg,
  color: theme.page.nextStepBtn.text,

  cursor: 'pointer',

  transition: [
    'color 0.3s ease-in-out',
    'background-color 0.3s ease-in-out',
  ].join(', '),

  '@media (prefers-reduced-motion)': {
    transition: 'none',
  },

  '&:not([disabled]):hover': {
    color: theme.page.nextStepBtn.textHover,
    backgroundColor: theme.page.nextStepBtn.bgHover,
    borderColor: 'transparent',
  },

  '&:focus': {
    outline: `3rem solid ${theme.page.nextStepBtn.borderFocus}`,
  },

  '&[disabled]': {
    cursor: 'not-allowed',

    opacity: 0.3,
  },

  '&[data-style="remove-secondary"]': {
    borderColor: 'transparent',
  },

  '&[data-style="warning-secondary"]': {
    borderColor: 'transparent',

    '&:hover': {
      borderColor: theme.palette.meatBrown,
      backgroundColor: theme.palette.white,
      color: theme.palette.meatBrown,
    },
  },

  '&[data-style="warning-primary"]:hover': {
    backgroundColor: theme.palette.meatBrown,
  },
}));
